import * as Yup from 'yup';
import formModel from './formModel';

const {
    firstName,
    lastName,
    email,
    contactNumber,
    role,
    roleOther,
    dietaryRequirements,
    dietaryOther,
} = formModel;

// Local (0821234567) or international (+27821234567) South African numbers, spaces/dashes allowed
const saContactNumber = /^(?:\+?27|0)[\s-]?(?:\d[\s-]?){8}\d$/;

const validationSchema = Yup.object().shape({
    [firstName.name]: Yup.string().trim().required(`${firstName.requiredErrorMsg}`),
    [lastName.name]: Yup.string().trim().required(`${lastName.requiredErrorMsg}`),
    [email.name]: Yup.string()
        .trim()
        .email('Incorrect email format')
        .required(`${email.requiredErrorMsg}`),
    [contactNumber.name]: Yup.string()
        .trim()
        .matches(saContactNumber, 'Not a valid South African contact number')
        .required(`${contactNumber.requiredErrorMsg}`),
    [role.name]: Yup.string().required(`${role.requiredErrorMsg}`),
    [roleOther.name]: Yup.string().when(role.name, {
        is: 'Other',
        then: Yup.string().trim().required(`${roleOther.requiredErrorMsg}`),
        otherwise: Yup.string().notRequired(),
    }),
    [dietaryRequirements.name]: Yup.string().required(`${dietaryRequirements.requiredErrorMsg}`),
    [dietaryOther.name]: Yup.string().when(dietaryRequirements.name, {
        is: 'Other',
        then: Yup.string().trim().required(`${dietaryOther.requiredErrorMsg}`),
        otherwise: Yup.string().notRequired(),
    }),
});

export default validationSchema;
